export type MapProvider = 'google' | 'osm';

export interface Coordinates {
  lat: number;
  lng: number;
}

export const toFiniteCoordinate = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const getCoordinates = (latitude: unknown, longitude: unknown): Coordinates | null => {
  const lat = toFiniteCoordinate(latitude);
  const lng = toFiniteCoordinate(longitude);

  if (lat === null || lng === null) {
    return null;
  }

  return { lat, lng };
};

export const getClientCoordinates = (client: { latitude?: unknown; longitude?: unknown }): Coordinates | null => {
  return getCoordinates(client.latitude, client.longitude);
};

export const buildGoogleEmbedUrl = (lat: number, lng: number): string => {
  return `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
};

export const buildGoogleViewUrl = (lat: number, lng: number): string => {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
};

export const buildOsmEmbedUrl = (lat: number, lng: number): string => {
  const delta = 0.01;
  const left = lng - delta;
  const right = lng + delta;
  const bottom = lat - delta;
  const top = lat + delta;

  return `https://www.openstreetmap.org/export/embed.html?bbox=${left},${bottom},${right},${top}&layer=mapnik&marker=${lat},${lng}`;
};

export const buildOsmViewUrl = (lat: number, lng: number): string => {
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=15/${lat}/${lng}`;
};